import { lazy } from "react";

export default {
  name: "TestComponent",
  path: "/testComponent",
  component: lazy(() => import("./index"))
}